const features = [
  {
    icon: 'ri-stack-line',
    title: '资源聚合',
    desc: '把散落在各处的影视信息与播放入口集中到一处，减少反复搜索的时间。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '更新及时',
    desc: '热门剧集跟随播出节奏同步上新，新片整理完成后尽快补充到片库。',
  },
  {
    icon: 'ri-hd-line',
    title: '画质清晰',
    desc: '提供标清到超清的多档清晰度，播放器会随网速自动匹配，观看更顺畅。',
  },
  {
    icon: 'ri-device-line',
    title: '多端可用',
    desc: '手机、平板与电脑浏览器均可直接打开观看，也支持投屏到大屏设备。',
  },
];

export default function AboutSite() {
  return (
    <section id="about" className="py-16 md:py-24 bg-background-100/60">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16">
          <div>
            <span className="inline-flex items-center gap-1.5 text-xs md:text-sm font-medium tracking-widest uppercase text-accent-700">
              <span className="w-1.5 h-1.5 rounded-full bg-accent-500"></span>
              关于本站
            </span>
            <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mt-3 leading-snug">
              星辰影院，让你更快找到想看的片子
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mt-5">
              星辰影院是一个面向中文观众的影视内容聚合站点。我们希望把「找片—试看—观看」这条路径变短，
              因此把最新电影、热门电视剧和经典老片整理在同一页面里，配上清晰的分类、评分与简介，
              让你不必在多个页面之间来回切换。
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mt-4">
              站内所有内容都以浏览体验为先：加载轻、结构清楚、手机同样可读。无论你是想随手点开一部消磨时间，
              还是认真规划一场追剧，都能在这里找到合适的选择。
            </p>

            <div className="mt-7 rounded-xl bg-background-50 border border-background-200/80 p-4 md:p-5">
              <div className="flex items-center gap-2 text-foreground-950">
                <i className="ri-shield-check-line text-primary-600"></i>
                <span className="font-heading text-sm font-bold">免责声明</span>
              </div>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed mt-2">
                本站不存储任何影音文件，仅提供影视信息的整理与检索服务。页面中的作品信息、评分与简介用于展示与介绍，
                相关版权归原始权利人所有。若权利人认为内容不妥，可联系删除处理。
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {features.map((f) => (
              <div
                key={f.title}
                className="p-5 rounded-xl bg-background-50 border border-background-200/70"
              >
                <span className="w-11 h-11 rounded-lg bg-primary-100 text-primary-700 flex items-center justify-center">
                  <i className={`${f.icon} text-xl`}></i>
                </span>
                <h3 className="font-heading text-base font-bold text-foreground-950 mt-4">
                  {f.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed mt-2">
                  {f.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}